import { render, staticRenderFns } from "./CommentContainer.vue?vue&type=template&id=2755e9fe&scoped=true"
import script from "./CommentContainer.vue?vue&type=script&lang=js"
export * from "./CommentContainer.vue?vue&type=script&lang=js"
import style0 from "./CommentContainer.vue?vue&type=style&index=0&id=2755e9fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755e9fe",
  null
  
)

export default component.exports